export default "__VITE_ASSET__x5jnItIc__"